export enum DialogNameEnum {
  PRODUCT_BY_ID = 'product-dialog-',
  SHOPPING_CART = 'shopping-cart',
  ACCOUNT_ACTIVATION_SUCCESS = 'account-activation-success',
  PROFILE_QUICK_AUTH = 'profile-quick_auth',
  AUTH_MODAL = 'auth-modal',
  AUTH_FORGOT_PASSWORD = 'auth-forgot-password',
  LANGUAGE_SELECTION = 'language-selection',
  ANNOUNCEMENTS = 'announcements',
  LOCATION_CONFIRMATION = 'location-confirmation',
  DELIVERY_METHOD_CONFIRMATION = 'ordering-methods-confirmation',
  THANK_YOU_FOR_YOUR_ORDER = 'thank-your-for-your-order-dialog',
  ORDER_VALIDATING_PAYMENT = 'order_validating_payment',
  DEV_MODE = 'dev-mode-dialog',
  DELIVERY_ADDRESS = 'delivery-address-dialog'
}

export enum AuthenticationFlowDialogNameEnum {
  AUTHENTICATION_FLOW_LOGIN_TYPE_SELECTION = 'authentication-flow-login-type-selection',
  AUTHENTICATION_FLOW_LOGIN = 'authentication-flow-login',
  AUTHENTICATION_FLOW_CUSTOMER_MISSING_FIELDS = 'authentication-flow-customer-missing-fields',
  AUTHENTICATION_FLOW_GUEST_MISSING_FIELDS = 'authentication-flow-guest-missing-fields',
  AUTHENTICATION_FLOW_CONFIRMATION_CODE = 'authentication-flow-confirmation-code',
  AUTHENTICATION_FLOW_REGISTER = 'authentication-flow-register',
  AUTHENTICATION_FLOW_REGISTER_CONFIRMATION = 'authentication-flow-register-confirmation',
  AUTHENTICATION_FLOW_RESET_PASSWORD = 'authentication-flow-reset-password',
  AUTHENTICATION_FLOW_SUCCESSFUL = 'authentication-flow-successful',
}
